import { JSX, useEffect, useState } from 'react'
import { Node, Path } from 'slate'
import { useSlate } from 'slate-react'

import { getDropdownFormatInSelectedNode } from '../../helpers/dropDownFormatHelper'
import { IBaseDropDown, IPropsForRender } from '../../interface/IToolbarProps'

import { BaseDropDown } from './BaseDropDown'

interface IProps<T> {
  component: (props: IPropsForRender<T> & IBaseDropDown<T>) => JSX.Element
}

export function BlockStyleDropDown<T>(props: IProps<T> & IBaseDropDown<T>) {
  const [format, setFormat] = useState('')
  const editor = useSlate()

  useEffect(() => {
    const { selection } = editor
    if (!selection) return

    const selectedNodePath = Path.parent(selection.anchor.path)
    const selectedNode = Node.get(editor, selectedNodePath)
    const selectedBlockFormatFromInputFormats = getDropdownFormatInSelectedNode(
      selectedNode,
      props.formatKeyField,
      props.formats
    )

    setFormat(selectedBlockFormatFromInputFormats)
  })

  return <BaseDropDown {...props} format={format} />
}
